import { createFileRoute, redirect } from "@tanstack/react-router";

// Account + security settings live on /profile. The previous /settings page was an
// unwired mock (and included a dark-mode toggle, which the light-only brand forbids),
// so this route now redirects to the real account page.
export const Route = createFileRoute("/settings")({
  beforeLoad: () => {
    throw redirect({ to: "/profile" });
  },
});
